import {
  BMButton,
  BMPopup,
  BMPrimitives,
  BMText,
} from "@traveloka/district-bloom";
import IcSystemLogOut16 from "@traveloka/icon-kit-web/react/IcSystemLogOut16";
import { Fragment, useEffect, useId, useState } from "react";
import { StyleSheet } from "react-native";
import { useScrollLock } from "../../../../components";
import modalManager from "../../../../components/Modal/ModalManager";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { appendTestId } from "../../../../utils";
import MenuItem from "../MenuItem";

type Props = {
  onLogout: () => void;
};

const testID = "logout";

export default function LogoutMenu({ onLogout }: Props) {
  const { CorporateNavigationMenuList: cr } = useMobileContentResource();
  const [confirmationVisible, setConfirmationVisible] = useState(false);

  const modalID = useId();
  useScrollLock(!modalManager.empty);

  function handleOpenConfirmationModal() {
    setConfirmationVisible(true);
    modalManager.add(modalID, setConfirmationVisible);
  }

  function handleCloseConfirmationModal() {
    modalManager.remove(modalID);
  }

  useEffect(() => {
    return () => modalManager.remove(modalID);
  }, [modalID]);

  return (
    <Fragment>
      <MenuItem
        title={cr.logout}
        Icon={IcSystemLogOut16}
        onClick={handleOpenConfirmationModal}
        testID={testID}
      />
      <BMPopup
        isVisible={confirmationVisible}
        onPopupClose={handleCloseConfirmationModal}
      >
        <BMView
          style={styles.wrapper}
          spacing="lg"
          testID={appendTestId(testID, "container")}
        >
          <BMText variant="titleNormal" testID={appendTestId(testID, "title")}>
            {cr.logoutModalTitle}
          </BMText>
          <BMText
            variant="paragraphNormal"
            testID={appendTestId(testID, "description")}
          >
            {cr.logoutModalDescription}
          </BMText>
          <BMView row justify="center" spacing="sm">
            <BMView flex>
              <BMButton
                label={cr.logoutModalLogoutCTA}
                size="LARGE"
                role="SECONDARY"
                onPress={onLogout}
                stretchable
                testID={appendTestId(testID, "confim_button")}
              />
            </BMView>
            <BMView flex>
              <BMButton
                label={cr.logoutModalCancelCTA}
                size="LARGE"
                role="PRIMARY"
                onPress={handleCloseConfirmationModal}
                stretchable
                testID={appendTestId(testID, "cancel_button")}
              />
            </BMView>
          </BMView>
        </BMView>
      </BMPopup>
    </Fragment>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: BMPrimitives.BMSize.xl,
  },
});
